import { TransformErrorMessageFn } from "@/components/ui/form"

const transformError: TransformErrorMessageFn = (i18nKey: string) => {
  const splittedKey = i18nKey.split(".")

  if (splittedKey[0] === "TErrors") {
    return {
      message: `${splittedKey[0]}.${splittedKey[1]}`,
      messageProps: Object.assign(
        {},
        ...splittedKey.slice(2).map((p, i) => {
          return { [`value${i}`]: p }
        }),
      ),
    }
  } else {
    return { message: i18nKey }
  }
}
export { transformError }
